import React from "react";

interface GlobalContextInterface {
  fontSize?: { get: number; set: (size: number) => void };
  superFooter?: { get: boolean; set: (value: boolean) => void };
  genreSelected?: { get: string; set: (value: string) => void};
  gigyaUid?:  { get: string; set: (value: string) => void}
}

const context: GlobalContextInterface = {};

const GlobalContext = React.createContext(context);

export default GlobalContext;
